import React, { Component, Fragment } from 'react'
import { withSiteData } from 'react-static'

import ButtonLink from '../components/site/Button/ButtonLink'
import Footer from '../blocks/NewFooter/NewFooterV2'
import Heading1 from '../components/site/typography/Heading1'
import Heading4 from '../components/site/typography/Heading4'

import './404v2.scss'

class PageNotFound extends Component {
    constructor(props) {
        super(props)

        this.state = {
            referrer: ''
        }
    }

    setReferrer() {
        this.setState({
            referrer: document.referrer || 'https://mercos.com'
        })
    }

    componentDidMount() {
        this.setReferrer()
    }

    render() {
        return(
            <Fragment>
                <div className='not-found-container new-not-found-container'>

                    <div className='container'>
                        <img className='logo-mercos' src="/images/logo-mercos-white.svg" alt="Logomarca Mercos" />
                        <h2 center>Oooops...</h2>
                        <h1 center>Essa página não existe, você digitou o endereço certo?</h1>
                        <a href={ this.state.referrer } center radius='half-rounded' title='Voltar para a página anterior.'> &#8249; VOLTAR PARA A PÁGINA ANTERIOR</a>
                    </div>
                    <img className='not-found-illustration' alt='A página que você tentou acessar não está disponível.' src='/images/site/new-page-not-found-illustration.svg'/>
                </div>
            </Fragment>
        )
    }
}

export default PageNotFound



// WEBPACK FOOTER //
// /usr/src/site-blog/src/containers/404v2.jsx